import { render } from "./InjurySite.vue?vue&type=template&id=59351a5d&scoped=true"
import script from "./InjurySite.vue?vue&type=script&lang=js"
export * from "./InjurySite.vue?vue&type=script&lang=js"

import "./InjurySite.vue?vue&type=style&index=0&id=59351a5d&lang=scss&scoped=true"
import "./InjurySite.vue?vue&type=style&index=1&id=59351a5d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59351a5d"]])

export default __exports__